import { resolveSiteLocale } from './siteLocale';
// request.ts
import axios from 'axios';

let isRedirectingToLogin = false;

const AUTH_REDIRECT_EXCLUDED_PATTERN =
    /^\/(?:en|pl)\/(?:login|register|reset-password)\/?$/;

const isAuthRedirectExcludedRoute = (path: string) =>
    AUTH_REDIRECT_EXCLUDED_PATTERN.test(path);

// better than endpoint-name matching
const isSessionExpired401 = (error: any) => error?.response?.status === 401;

const isMeRequest = (error: any) => {
    const url = error?.config?.url || '';
    return url.includes('/auth/me');
};

const request = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

request.interceptors.response.use(
    r => r,
    error => {
        const { pathname, search, hash } = window.location;

        if (isAuthRedirectExcludedRoute(pathname)) {
            isRedirectingToLogin = false;
        }

        if (
            isSessionExpired401(error) &&
            !isAuthRedirectExcludedRoute(pathname) &&
            !isMeRequest(error) &&
            !isRedirectingToLogin
        ) {
            isRedirectingToLogin = true;

            const locale = resolveSiteLocale(pathname);
            const from = encodeURIComponent(`${pathname}${search}${hash}`);

            window.location.assign(
                `/${locale}/login?expired=true&from=${from}`
            );
        }

        return Promise.reject(error);
    }
);

export default request;
